import { FC, ReactNode, useState } from 'react';
import { Modal, ModalProps } from 'rsuite';

type VoidFn = () => void;

export interface RsModalTriggerProps {
  renderModalTrigger(openModal: VoidFn, closeModal?: VoidFn): ReactNode;
  renderModalContent(closeModal: VoidFn): ReactNode;
  className?: string;
  modalProps?: Omit<ModalProps, 'className'>;
  defaultOpen?: boolean;
}

export const RsModalTrigger: FC<RsModalTriggerProps> = ({
  renderModalTrigger,
  renderModalContent,
  className = '',
  modalProps = {},
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {renderModalTrigger(handleOpen, handleClose)}
      <Modal
        {...modalProps}
        size={modalProps.size || 'lg'}
        open={open}
        onClose={handleClose}
        className={className}
      >
        {renderModalContent(handleClose)}
      </Modal>
    </>
  );
};
